import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
};

export const RequireAuth = ({ children }: Props) => {
  const { authState } = useOktaAuth();

  // if not logged in, redirect back to login
  if (!(authState && authState.isAuthenticated)) {
    return <Navigate to={{ pathname: '/login' }} />;
  }

  // we need to determine type of user and route them properly to their index
  return <>{children}</>;
};
